var map = {
	"./en/btn-email.png": "f864",
	"./en/btn-ota-no.png": "6525",
	"./en/btn-others.png": "7976",
	"./en/btn-phone.png": "88ec",
	"./en/btn-pre-reservation-no.png": "97a4",
	"./en/btn-reservation-no.png": "394d",
	"./ja/btn-email.png": "bd0c",
	"./ja/btn-ota-no.png": "634d",
	"./ja/btn-others.png": "a795",
	"./ja/btn-phone.png": "c18c",
	"./ja/btn-pre-reservation-no.png": "69f1",
	"./ja/btn-reservation-no.png": "1a74",
	"./my-page/hotel_staff_face_icon.png": "123e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5441";